import ShareIcon from "@mui/icons-material/Share";
import { Button, Tooltip } from "@mui/material";

interface Props {
  onClick: () => void;
}

export function PublicShipmentShareButton(props: Props) {
  const { onClick } = props;
  return (
    <Tooltip title="Share this shipment's public tracking link">
      <Button
        variant="contained"
        color="primary"
        size="small"
        startIcon={<ShareIcon />}
        onClick={onClick}
        sx={{ textTransform: "none", flexShrink: 0 }}
      >
        Share
      </Button>
    </Tooltip>
  );
}
